import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import Form from "@/components/Shared/Form";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import { motion } from 'framer-motion';
import React, { useRef, useState, useEffect } from 'react';

export default function BenefitsAtTradeWind({
    className,
    global,
    pathPrefix,
    post,
    heading,
    content
}) {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const [open, setOpen] = useState('0');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            <section ref={sectionRef} className={clsx(className, styles.root)}>
                <Container>
                    <div className='wrapper align-items-center'>
                        <div>
                            {heading && (
                                <EditableText
                                    content={heading}
                                    path={`${pathPrefix}.heading`}
                                    global={global}
                                    tag={`h3`}
                                    className={`h3`}
                                />
                            )}
                            {content && (
                                <EditableText
                                    content={content}
                                    path={`${pathPrefix}.content`}
                                    global={global}
                                    tag={`div`}
                                    className={`content`}
                                    html={true}
                                />
                            )}
                        </div>
                        <div className='column-wrapper'>
                            {post?.length >= 1 && (
                                post.map((post, index) => (
                                    <motion.div className={`column`} key={index} initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: index * 0.1 }}>
                                        <EditableImage
                                            img={post?.image ? post.image : "/public/images/placeholders/img-placeholder.jpg"}
                                            size={`x60`}
                                            alt={`${post.title}`}
                                            height={`100%`}
                                        />
                                        <div>{post.title}</div>
                                        {post.content && (
                                            <div dangerouslySetInnerHTML={{ __html: post.content }} />
                                        )}
                                    </motion.div>
                                ))
                            )}
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}

BenefitsAtTradeWind.defaultProps = {
    pathPrefix: "",
    className: "py-5",

};

BenefitsAtTradeWind.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};